<div class="cnt-column" attr.data-testid="{{testId}}-container">
    <div #itemrow
         class="cnt-row option {{titleRowCls}}"
         style="align-items:center"
         (click)="onItemClick()"
         attr.data-testid="{{testId}}-header">
        <div #img attr.data-testid="{{testId}}-img"></div>
        <div #space></div>
        <div class="{{titleTxtCls}}">{{itemText}}</div>
    </div>
    <div class="cnt-row"
         attr.data-testid="{{testId}}-body">
        <div #bottomspace></div>
        <ng-container *ngIf="expanded">
            <div #itmtext class='item-text' style="flex: 1"><ng-content></ng-content></div>
        </ng-container>
    </div>

</div>